module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('b', [_vm._v("acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_vm._v("Thank you to everyone at C&T Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('span', {
    staticClass: "vio"
  }, [_c('b', [_c('i', [_vm._v("Special thanks to:")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("Helen Frost, my technical editor. Helen and I have worked on nearly all of my books, and I have come to consider her not only a friend but the best technical editor ever.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("Diane Minkley of Patched Works, Inc. Diane has been the longarm quilter on most of my books. I truly appreciate all you do.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("My daughter, Ali May. You rock at “name that quilt.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("My husband, Gary. He has typed all my books and over the years has become a very good pre-editor in his own right. Thanks, hon.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg3_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e28bac7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Acknowledgments.vue
// module id = 63
// module chunks = 0